import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

export const OWNER_PORTAL_USER_FIELDS = `
  id
  role
  ownerType
  ownerId
  ownerName
  portalUser {
    id
    email
    officePhone { value, formatted }
    mobilePhone { value, formatted }
    fullName
    firstName
    lastName
  }
`;

export const OWNER_PORTAL_USERS = gql`
  query OwnerPortalUser {
    currentOwner {
      name
      ownerPortalUsers {
        ${OWNER_PORTAL_USER_FIELDS}
      }
    }
  }
`;

export const OWNER_PORTAL_USER = gql`
  query OwnerPortalUser($id: ID!) {
    ownerPortalUser(id: $id) {
      ${OWNER_PORTAL_USER_FIELDS}
    }
  }
`;

const OWNER_PORTAL_USER_VARIABLES = `
  $role: String!
  $portalUserAttributes: PortalUserInput!
`;

const OWNER_PORTAL_USER_ARGUMENTS = `
  role: $role
  portalUserAttributes: $portalUserAttributes
`;

export const CREATE_OWNER_PORTAL_USER = gql`
  mutation CreateOwnerPortalUser(
    ${OWNER_PORTAL_USER_VARIABLES}
  ) {
    createOwnerPortalUser(
      ${OWNER_PORTAL_USER_ARGUMENTS}
    ) {
      ${ERRORS}
    }
  }
`;

export const UPDATE_OWNER_PORTAL_USER = gql`
  mutation UpdateOwnerPortalUser(
    $id: ID!
    ${OWNER_PORTAL_USER_VARIABLES}
  ) {
    updateOwnerPortalUser(
      id: $id
      ${OWNER_PORTAL_USER_ARGUMENTS}
    ) {
      ${ERRORS}
    }
  }
`;

export const DELETE_OWNER_PORTAL_USER = gql`
  mutation DeleteOwnerPortalUser($id: ID!) {
    deleteOwnerPortalUser(id: $id) {
      ${ERRORS}
    }
  }
`;
